/** Clinical Precision System (Stitch) — shared tokens for ConfigProvider + CSS vars. */
export var clinicalPrecisionColors = {
    primary: '#0EA5E9',
    primaryHover: '#0284C7',
    primaryActive: '#1E3A8A',
    secondary: '#1E3A8A',
    tertiary: '#10B981',
    canvas: '#F1F5F9',
    canvasSubtle: '#F8FAFC',
    surface: '#FFFFFF',
    border: '#CBD5E1',
    borderMuted: '#E2E8F0',
    text: '#0F172A',
    textSecondary: '#475569',
    textMuted: '#64748B',
    menu: '#0F172A',
    selectedMenuBg: '#E0F2FE',
    selectedMenuText: '#0284C7',
    success: '#10B981',
    warning: '#D97706',
    error: '#DC2626',
    errorContainer: '#FEF2F2',
    focusRing: 'rgba(14, 165, 233, 0.20)',
};
export var clinicalPrecisionFonts = {
    sans: "'Inter', system-ui, -apple-system, sans-serif",
    label: "'Public Sans', 'Inter', system-ui, sans-serif",
};
export var clinicalPrecisionTheme = {
    token: {
        colorPrimary: clinicalPrecisionColors.primary,
        colorInfo: clinicalPrecisionColors.primary,
        colorSuccess: clinicalPrecisionColors.success,
        colorWarning: clinicalPrecisionColors.warning,
        colorError: clinicalPrecisionColors.error,
        colorText: clinicalPrecisionColors.text,
        colorTextSecondary: clinicalPrecisionColors.textSecondary,
        colorBorder: clinicalPrecisionColors.border,
        colorBgLayout: clinicalPrecisionColors.canvas,
        colorBgContainer: clinicalPrecisionColors.surface,
        colorBgElevated: clinicalPrecisionColors.surface,
        borderRadius: 8,
        controlHeight: 36,
        fontFamily: clinicalPrecisionFonts.sans,
        fontSize: 13,
        wireframe: false,
    },
    components: {
        Button: {
            controlHeight: 36,
            borderRadius: 8,
            fontWeight: 600,
            primaryShadow: 'none',
        },
        Input: {
            controlHeight: 36,
            borderRadius: 8,
        },
        Select: {
            controlHeight: 36,
            borderRadius: 8,
        },
        DatePicker: {
            controlHeight: 36,
            borderRadius: 8,
        },
        Table: {
            headerBg: clinicalPrecisionColors.canvasSubtle,
            headerColor: clinicalPrecisionColors.textSecondary,
            borderColor: clinicalPrecisionColors.border,
            rowHoverBg: clinicalPrecisionColors.canvas,
            cellPaddingBlock: 8,
            cellPaddingInline: 12,
        },
        Menu: {
            itemBorderRadius: 8,
            itemHeight: 36,
            itemSelectedBg: clinicalPrecisionColors.selectedMenuBg,
            itemSelectedColor: clinicalPrecisionColors.selectedMenuText,
            itemHoverBg: clinicalPrecisionColors.canvas,
            itemColor: clinicalPrecisionColors.menu,
            iconSize: 18,
            fontSize: 13,
        },
        Layout: {
            bodyBg: clinicalPrecisionColors.canvas,
            siderBg: clinicalPrecisionColors.surface,
            headerBg: clinicalPrecisionColors.surface,
            triggerBg: clinicalPrecisionColors.borderMuted,
            triggerColor: clinicalPrecisionColors.text,
        },
        Drawer: {
            borderRadiusLG: 8,
        },
        Card: {
            borderRadiusLG: 8,
        },
        Notification: {
            borderRadiusLG: 8,
        },
    },
};
/** Sidebar width aligned with Stitch app shell (w-64 / 256px). */
export var SIDEBAR_WIDTH = 256;
export var SIDEBAR_COLLAPSED_WIDTH = 72;
/**
 * Stitch parity gate (Clinical Precision / clinic manager project).
 * Check off against Stitch screens before considering antd 6.
 */
export var stitchParityChecklist = [
    { id: 'shell', stitch: 'App shell — expanded', app: 'Layout + SideBar', focus: 'nav selected ice, canvas #F1F5F9, 256px sider' },
    { id: 'tokens', stitch: 'Clinic Manager — Clinical style sheet', app: 'ConfigProvider + style.css', focus: 'primary #0EA5E9, 8px radius, 36px controls, Inter/Public Sans' },
    { id: 'headers', stitch: 'Page headers', app: 'PageHeader/*', focus: 'fixed header, search 36px, primary CTA' },
    { id: 'opd-home', stitch: 'Home', app: 'pages/Home', focus: 'queue cards, hairline dividers' },
    { id: 'opd-patients-list', stitch: 'Patients — list', app: 'pages/Patients', focus: 'registry table, search By field, export CSV' },
    { id: 'opd-patients', stitch: 'Patient — Sara Nasser / Packages / Financials / Journeys / Visits', app: 'pages/ShowPatient', focus: 'hero, info cards, tab panels' },
    { id: 'opd-journeys', stitch: 'Patient journeys / Station queue', app: 'pages/PatientJourneys', focus: 'primary accents, cards' },
    { id: 'staff-doctors-list', stitch: 'Doctors — Directory', app: 'pages/Doctors', focus: 'header count, filter toolbar, 4-col specialty cards' },
    { id: 'staff-doctors-show', stitch: 'Doctor — Dr. Maya Haddad', app: 'pages/ShowDoctor', focus: 'hero back/status, personal+contact cards, schedules table' },
    { id: 'staff', stitch: 'Employees / Medical machines', app: 'Employees|MedicalMachines', focus: 'list + show radius/border' },
    { id: 'inventory', stitch: 'Products / Suppliers / Stock movements', app: 'pages/inventory/*', focus: 'list/show panels' },
    { id: 'accounting', stitch: 'Documents / Transactions', app: 'pages/accounting/*', focus: 'list/show panels' },
    { id: 'settings-reports', stitch: 'Settings / Reports', app: 'Settings|Reports', focus: 'inherits theme; RTL spot-check' },
];
